import React from "react";
import styled from "styled-components";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
function Header() {
  const [burgerStatus, setburgerStatus] = React.useState(true);
  //console.log(cars);
  return (
    <div>
      <Container>
        <a>
          <img src="/images/logo.svg" />
        </a>
        <Menu>
          <a href="#">Model S</a>

          <a href="#">Model 3</a>

          <a href="#">Model X</a>

          <a href="#">Model Y</a>

          <a href="#">SOLAR ROOF</a>
          <a href="#">SOLAR PANELS</a>
        </Menu>
        <RightMenu>
          <a href="#">Shop</a>
          <a href="#">Tesla account</a>
        </RightMenu>
        <CustomMenu onClick={() => setburgerStatus(false)} />
        <BurgerMenu show={burgerStatus}>
          <Close>
            <CustomCloseButton onClick={() => setburgerStatus(true)} />
          </Close>
          <ui>
            <li>
              <a href="#">Existing Inventory</a>
            </li>
            <li>
              <a href="#">used inventory</a>
            </li>
            <li>
              <a href="#">trade-in</a>
            </li>
            <li>
              <a href="#">cybertruck</a>
            </li>
            <li>
              <a href="#">roadster</a>
            </li>
            <li>
              <a href="#">semi</a>
            </li>
            <li>
              <a href="#">charging</a>
            </li>
            <li>
              <a href="#">powerwall</a>
            </li>
            <li>
              <a href="#">commercial energy</a>
            </li>
            <li>
              <a href="#">utilities</a>
            </li>
            <li>
              <a href="#">test drive</a>
            </li>
            <li>
              <a href="#">find us</a>
            </li>
          </ui>
        </BurgerMenu>
      </Container>
    </div>
  );
}

export default Header;

const Container = styled.div`
  position: fixed;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;

  @media (max-width: 768px) {
    img {
      height: 15px;
    }
  }
`;
const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  a {
    font-weight: 600;
    text-transform: upperCase;
    padding: 0 10px;
    flex-wrap: nowrap;
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;
const RightMenu = styled.div`
  display: flex;
  align-items: center;
  a {
    font-weight: 600;
    text-transform: upperCase;
    padding: 0 10px;

    @media (max-width: 1200px) {
      display: none;
    }
  }
`;
const CustomMenu = styled(MenuIcon)`
  cursor: pointer;
  margin-right: 15px;
`;
const BurgerMenu = styled.div`
  position: fixed;
  background-color: #fff;
  top: 0;
  bottom: 0;
  right: 0;
  width: 300px;
  list-style: none;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: start;
  transform: ${(props) => (props.show ? `TranslateX(100%)` : `translateX(0)`)};
  transition: 0.1s;
  li {
    padding: 15px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }
  a {
    font-weight: 600;
  }
`;
const CustomCloseButton = styled(CloseIcon)`
  cursor: pointer;
  margin-right: 20px;
`;
const Close = styled.div`
  display: flex;
  justify-content: flex-end;
`;
